import { render, staticRenderFns } from "./StepFiltraProfissionais.vue?vue&type=template&id=72d61a60&scoped=true"
import script from "./StepFiltraProfissionais.vue?vue&type=script&lang=js"
export * from "./StepFiltraProfissionais.vue?vue&type=script&lang=js"
import style0 from "./StepFiltraProfissionais.vue?vue&type=style&index=0&id=72d61a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d61a60",
  null
  
)

export default component.exports